import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private currentUrl!: string;

  constructor(private router: Router) {
    // On refresh, restore currentUrl so the first NavigationEnd
    // can correctly save it as previousUrl
    this.currentUrl = sessionStorage.getItem('currentUrl') ?? '';

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (this.currentUrl) {
          sessionStorage.setItem('previousUrl', this.currentUrl);
        }
        this.currentUrl = event.urlAfterRedirects;
        sessionStorage.setItem('currentUrl', this.currentUrl);
      });
  }

  getPreviousUrl(): string | null {
    return sessionStorage.getItem('previousUrl');
  }

  public extractLastId(url: string): number | undefined {
    const segments = url.split('/').filter(s => s);
    const lastSegment = segments[segments.length - 1];
    const id = Number(lastSegment);
    return isNaN(id) ? undefined : id;
  }
}